<app-table
module="accounts"
pageTitle="Elenco Clienti"
newRecordUrl="accounts/accounts-edit/new"
editRecordUrl="accounts/accounts-edit/update/"
deleteRecordUrl="app/account_delete/"
listUrl="app/accounts_listall"
nuovoLabel="Nuovo cliente"
[listParams]="{logged_user_id:user_id}"></app-table>
